import { render, staticRenderFns } from "./UebersichtEingabenComponent.vue?vue&type=template&id=573eb2e9&scoped=true"
import script from "./UebersichtEingabenComponent.vue?vue&type=script&lang=js"
export * from "./UebersichtEingabenComponent.vue?vue&type=script&lang=js"
import style0 from "./UebersichtEingabenComponent.vue?vue&type=style&index=0&id=573eb2e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573eb2e9",
  null
  
)

export default component.exports